import { useEffect, useState } from "react";

/**
 * 뷰포트 너비가 `maxWidth` 미만인지.
 *
 * 넓은 표를 좁은 화면에서 카드로 바꿔 그릴 때 쓴다. **CSS 로 `hidden`/`block` 을 토글하는
 * 대신 이 훅으로 한쪽만 렌더한다** — 두 벌 모두 DOM 에 두면 같은 상품명·같은 `data-testid`
 * 가 문서에 두 번 존재해서, 테스트의 `getByText`/`getByTestId` 가 "여러 개를 찾았다" 로
 * 터지고 스크린리더도 목록을 두 번 읽는다.
 *
 * `matchMedia` 가 아니라 `innerWidth` 를 보는 이유: jsdom 은 `matchMedia` 의 `matches` 를
 * 항상 false 로 돌려주고 테스트마다 별도 mock 을 요구하는데, `innerWidth` 는 기본값(1024)이
 * 그대로 있어 추가 설정 없이 데스크톱 경로가 잡힌다.
 *
 * SSR·최초 렌더에서는 `false`(= 넓은 화면) 로 시작한다. 좁은 화면에서는 마운트 직후
 * effect 가 한 번 더 그린다.
 */
export function useNarrowViewport(maxWidth: number): boolean {
  const [isNarrow, setIsNarrow] = useState(false);

  useEffect(() => {
    const check = () => {
      setIsNarrow(window.innerWidth < maxWidth);
    };
    check();
    window.addEventListener("resize", check);
    return () => {
      window.removeEventListener("resize", check);
    };
  }, [maxWidth]);

  return isNarrow;
}

/** Tailwind 기본 브레이크포인트 — 이 값들을 각 컴포넌트에 흩뿌리지 않는다. */
export const VIEWPORT_MD = 768;
export const VIEWPORT_LG = 1024;
